import AuthenticatedResource from 'resources/public/AuthenticatedResource'

export default class MetadataScraperResource extends AuthenticatedResource {
  static urlRoot = '/organizations/:organization_id/metadata_scraper' as const;

  readonly id: number | undefined = undefined;

  pk() {
    return this.id?.toString();
  }
}
